import { Flex } from "@redotech/redo-web/flex";
import { Footer } from "./footer";
import { Header } from "./header";
import { SingleOrderLogin } from "./single-order-login";
import { useGiftReceiptLogin } from "./use-gift-receipt-login";

type GiftReceiptLoginProps = {
  showFooter?: boolean;
  showLogo?: boolean;
  onBack?: () => void;
};

export function GiftReceiptLogin({
  showFooter = true,
  showLogo = true,
  onBack: onBackProp,
}: GiftReceiptLoginProps) {
  const { texts, logo, onBack } = useGiftReceiptLogin({ onBack: onBackProp });

  return (
    <Flex align="stretch" flexDirection="column" gap="3xl">
      <Header
        leftAlign={!showLogo}
        logo={showLogo ? logo : undefined}
        merchantName={texts.merchantName}
        onBack={onBack}
        subtitle={texts.subtitle}
        title={texts.title}
      />
      <SingleOrderLogin />
      {showFooter && <Footer centered />}
    </Flex>
  );
}
